module.exports = __webpack_public_path__ + "img/salepro.acfdd51c.svg";